import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import './RepaymentRemarksModal.css'

const LastRepaymentScheduleModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  createMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  scheduledDate, onScheduledDateChange, scheduledDateError, setScheduledDateError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add row'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputDateUI context={context} name='date' label='Scheduled date'
      selectedDateISO={scheduledDate} onChange={onScheduledDateChange}
      error={scheduledDateError} setError={setScheduledDateError}
    />

  </ModalFormUI>

export default LastRepaymentScheduleModalUI
